/*
  rk Scroll-Reveal
  [data-rk-reveal]          → Element blendet beim Scrollen einmalig ein
  [data-rk-reveal-stagger]  → Kinder des Containers blenden nacheinander ein

  Die Ausgangslage (unsichtbar) gilt nur, solange html.rk-reveal-on gesetzt ist.
  Diese Klasse setzt ein Inline-Script in layout/theme.liquid (nicht im Theme-Editor,
  nicht bei prefers-reduced-motion). Lädt dieses Script nicht, entfernt das
  Inline-Script die Klasse wieder – Inhalte bleiben also immer erreichbar.
*/
(() => {
  if (window.RkReveal) return;

  const root = document.documentElement;
  const SELECTOR = '[data-rk-reveal], [data-rk-reveal-stagger]';
  const THRESHOLD = 0.15;
  const MAX_STAGGER_INDEX = 12;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const showAll = () => root.classList.remove('rk-reveal-on');

  window.RkReveal = { showAll };

  if (!root.classList.contains('rk-reveal-on')) return;

  if ((window.Shopify && window.Shopify.designMode) || reducedMotion.matches || !('IntersectionObserver' in window)) {
    showAll();
    return;
  }

  reducedMotion.addEventListener?.('change', (event) => {
    if (event.matches) showAll();
  });

  const toMs = (value, fallback) => {
    const number = parseFloat(value);
    if (Number.isNaN(number)) return fallback;
    return value.trim().endsWith('ms') ? number : number * 1000;
  };

  const styles = getComputedStyle(root);
  const duration = toMs(styles.getPropertyValue('--rk-dur'), 700);
  const stagger = toMs(styles.getPropertyValue('--rk-stagger'), 80);

  const finish = (element, delay) => {
    window.setTimeout(() => element.classList.add('is-rk-done'), duration + delay + 50);
  };

  const reveal = (element) => {
    element.classList.add('is-rk-revealed');
    const count = element.hasAttribute('data-rk-reveal-stagger')
      ? Math.min(element.children.length, MAX_STAGGER_INDEX + 1)
      : 1;
    const ownDelay = toMs(getComputedStyle(element).getPropertyValue('--rk-reveal-delay'), 0);
    finish(element, (count - 1) * stagger + ownDelay);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const tallEnough = entry.intersectionRect.height >= window.innerHeight * THRESHOLD;
        if (entry.intersectionRatio < THRESHOLD && !tallEnough) return;
        observer.unobserve(entry.target);
        reveal(entry.target);
      });
    },
    { threshold: [0, THRESHOLD] }
  );

  const prepare = (element) => {
    if (element.dataset.rkRevealBound) return;
    element.dataset.rkRevealBound = 'true';
    if (element.hasAttribute('data-rk-reveal-stagger')) {
      Array.from(element.children).forEach((child, index) => {
        child.style.setProperty('--rk-reveal-index', Math.min(index, MAX_STAGGER_INDEX));
      });
    }
    observer.observe(element);
  };

  const scan = (scope) => {
    if (scope.matches?.(SELECTOR)) prepare(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(prepare);
  };

  scan(document);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) scan(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
